import axios from 'axios';

export default {
    FETCH_CONTENTS ({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            // axios.post('login/authenticate', payload)
            axios.get('registration/getPageNames')
                .then((response) => {
                    const { data: { data : { payload } } } = response;
                    localStorage.setItem('contents', JSON.stringify(payload));
                    commit('SET_CONTENTS', payload);
                    commit('TOGGLE_LOADING', false);
                    resolve(payload);

                })
                .catch((error) => {
                    console.log('action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    GETSELECTEDCONTENT ({ commit }, pageId) {
        commit('TOGGLE_LOADING', true);
        return axios.get(`/registration/getPageContents/${pageId}`).then((response) => {
            commit('TOGGLE_LOADING', false);
            const { data: { data : { payload } } } = response;
            commit('SET_SELECTED_CONTENT', payload)
        }, (err) => {
            commit('TOGGLE_LOADING', false);
            console.log('err ', err)
        })
    },
    UPDATE_CONTENT({commit, dispatch}, payload){
      return new Promise((resolve, reject) => {
        commit('TOGGLE_LOADING', true);
        axios.post('registration/updatePageContents', payload)
          .then((response) => {
            const { data: { data } } = response;
            commit('TOGGLE_LOADING', false);
            resolve(data);
          })
          .catch((error) => {
            console.log('UPDATE_CONTENT action fetch error : ', error);
            reject(error);
            commit('TOGGLE_LOADING', false);
          });
      })
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/contents/actions.js